/**
 * 注意这里不捕获异常
 * 如果不支持localStorage的异常处理需要业务自己处理
 */

// DONT USE Lodash like THIS:
// import _ from 'lodash';

import get from 'lodash/get';
import unset from 'lodash/unset';

const Storage = {
  getItem: function(key: any) {
    const { name, path } = getKeyInfo(key);
    let ret;
    const value = localStorage.getItem(name) || '';
    try {
      const valueObj = JSON.parse(value);
      if (path.length) {
        ret = get(valueObj, path);
      } else {
        ret = valueObj;
      }
    } catch (e) {
      ret = value;
    }
    return ret;
  },
  setItem: function(key: any, data: any) {
    const { name, path } = getKeyInfo(key);
    let value = Storage.getItem(name);
    if (typeof value !== 'object') {
      value = {};
    }
    if (!path.length) {
      value = data;
    } else {
      _set(value, path, data);
    }

    localStorage.setItem(name, JSON.stringify(value));
  },
  /**
   * 删除一个key
   * @param key
   */
  removeItem: function(key: any) {
    const { path, name } = getKeyInfo(key);

    if (path.length) {
      const value = Storage.getItem(name) || {};

      unset(value, path);
      Storage.setItem(name, value);
    } else {
      localStorage.removeItem(key);
    }
  },

  clear: function() {
    try {
      localStorage.clear();
    } catch (e) {
      // EMPTY_CATCH_LABEL
    }
  },
	/**
	 * set localStorage with expire time
	 */
	setCanExpireLocalStorage: function (key: string, value: any, expire: number) {
		if (isNaN(expire)) {
			throw new Error('Not a number');
		}
		let obj = {
			data: value,
			time: Date.now(),
			expire,
		};
		localStorage.setItem(key, JSON.stringify(obj));
	},

	/**
	 * get localStorage with expire time
	 */
	getCanExpireLocalStorage: function (key: string) {
		let val: any = localStorage.getItem(key);
		if (!val) return val;
		val = JSON.parse(val);
		if (Date.now() > val.time + val.expire) {
			localStorage.removeItem(key);
			return null;
		}
		return val.data;
	},
};

/**
 * @param key
 * @returns {{path: (Array|*), name: T}}
 */
function getKeyInfo(key: any) {
  const keyArr = key.split('.');
  const name = keyArr.splice(0, 1)[0];
  return {
    path: keyArr,
    name
  };
}

/**
 * @param obj
 * @param path
 * @param data
 * @private
 */
function _set(obj: any, path: any, data: any) {
  let currentObj = obj;
  let i = 0;
  if (typeof path === 'string') {
    path = path.split('.');
  }

  for (let len = path.length; i < len - 1; i++) {
    const item = path[i];
    currentObj[item] =
      typeof currentObj[item] === 'object' ? currentObj[item] : {};
    currentObj = currentObj[item];
  }
  currentObj[path[i]] = data;
  return obj;
}

export default Storage;
